import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Badge } from '@/components/ui/badge';
import { Save } from 'lucide-react';

const getCategoryShortName = (key) => key.replace('cat_', 'Cat. ').toUpperCase().replace('CAT. ', 'Cat. ');

function PricingHallSection({ hallPrefix, hallName, pricingObj, setPricingObj, categories }) {
  return (
    <div className="space-y-4">
      <h3 className="font-semibold text-lg border-b pb-2">{hallName}</h3>
      <div className="space-y-2">
        <h4 className="font-medium text-sm text-muted-foreground">Costo Cucina</h4>
        <div className="grid grid-cols-3 gap-3">
          {["1", "2", "3"].map(t => (
            <div key={t} className="space-y-1">
              <Label className="text-xs">{t === "1" ? "Associazioni di pubblica utilit\u00e0 residenti" : t === "2" ? "Associazioni non residenti e persone residenti" : "Non residenti"}</Label>
              <Input
                type="number" step="0.01"
                value={pricingObj[`cucina_${hallPrefix}_prezzo_${t}`] ?? 0}
                onChange={(e) => setPricingObj({ ...pricingObj, [`cucina_${hallPrefix}_prezzo_${t}`]: parseFloat(e.target.value) || 0 })}
                className="text-center text-base"
                data-testid={`input-cucina-${hallPrefix}-prezzo-${t}`}
              />
            </div>
          ))}
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-sm">
          <thead>
            <tr className="border-b">
              <th className="text-left p-2">Categoria</th>
              <th className="text-center p-2 text-xs">Ass. pubbl. util. residenti</th>
              <th className="text-center p-2 text-xs">Ass. non res. / Pers. residenti</th>
              <th className="text-center p-2 text-xs">Non residenti</th>
            </tr>
          </thead>
          <tbody>
            {categories.map((cat) => (
              <tr key={cat.key} className="border-b" data-testid={`pricing-row-${cat.key}-${hallPrefix}`}>
                <td className="p-2">
                  <span className="font-semibold">{getCategoryShortName(cat.key)}</span>
                  {cat.label && <p className="text-xs text-muted-foreground mt-0.5 max-w-[200px] truncate">{cat.label.substring(cat.label.indexOf(':') + 1).trim() || cat.label}</p>}
                  {!cat.active && <Badge variant="secondary" className="text-xs ml-1">Vuota</Badge>}
                </td>
                {["1", "2", "3"].map(t => (
                  <td key={t} className="p-1">
                    <Input
                      type="number" step="0.01"
                      value={pricingObj[`${cat.key}_${hallPrefix}_prezzo_${t}`] ?? 0}
                      onChange={(e) => setPricingObj({ ...pricingObj, [`${cat.key}_${hallPrefix}_prezzo_${t}`]: parseFloat(e.target.value) || 0 })}
                      className="text-center text-base min-w-[100px]"
                      data-testid={`price-${cat.key}-${hallPrefix}-prezzo-${t}`}
                    />
                  </td>
                ))}
              </tr>
            ))}
            <tr className="bg-green-50 dark:bg-green-900/20">
              <td className="p-2 font-semibold text-green-800 dark:text-green-200">Comune/Scuole</td>
              <td className="p-2 text-center font-bold text-green-700 dark:text-green-300">GRATIS</td>
              <td className="p-2 text-center font-bold text-green-700 dark:text-green-300">GRATIS</td>
              <td className="p-2 text-center font-bold text-green-700 dark:text-green-300">GRATIS</td>
            </tr>
            <tr className="bg-green-50 dark:bg-green-900/20">
              <td className="p-2 font-semibold text-green-800 dark:text-green-200">Anziani</td>
              <td className="p-2 text-center font-bold text-green-700 dark:text-green-300">GRATIS</td>
              <td className="p-2 text-center font-bold text-green-700 dark:text-green-300">GRATIS</td>
              <td className="p-2 text-center font-bold text-green-700 dark:text-green-300">GRATIS</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function AdminPricingTab({ pricing, setPricing, categories, onSave, saving }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="font-heading text-2xl">Configurazione Prezzi</CardTitle>
        <p className="text-sm text-muted-foreground">Prezzi separati per ogni sala.</p>
      </CardHeader>
      <CardContent className="space-y-8">
        <PricingHallSection hallPrefix="domene" hallName="Salf Dom\u00ebne Moling" pricingObj={pricing} setPricingObj={setPricing} categories={categories} />
        <PricingHallSection hallPrefix="pice" hallName="Pice salf" pricingObj={pricing} setPricingObj={setPricing} categories={categories} />
        <Button onClick={onSave} disabled={saving} className="btn-scale" data-testid="save-pricing-button">
          <Save className="w-4 h-4 mr-2" />{saving ? 'Salvataggio...' : 'Salva Tutti i Prezzi'}
        </Button>
        <div className="p-4 rounded-lg bg-muted">
          <p className="text-sm text-muted-foreground"><strong>Nota:</strong> Comune/Scuole \u00e8 sempre gratuito. La cucina viene calcolata automaticamente in base al tipo richiedente e alla sala.</p>
        </div>
      </CardContent>
    </Card>
  );
}
